



















































































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
// import { getCompanyInfoRequest} from '@/api/energySavingSupervision'
import { getProductEnergyRequest } from '@/api/enerySupervision'
import NoData from '@/components/NoData'

const echarts = require('echarts')

@Component({
  components: {
    NoData,
  },
  filters: {
    dateFilter: (value: string) => {
      if (!value) {
        return ''
      }

      return value.toString().indexOf('-') > -1
        ? value.split('-')[0] + '年' + value.split('-')[1] + '月'
        : value + '年'
    },
  },
})
export default class Login extends Vue {
  private year: any = moment(new Date().getFullYear(), 'YYYY');
  private yearShowOne: boolean = false;
  private tiemDefaultValue: string = '全年';
  private timeArr: any[] = [
    { value: '全年', id: `00` },
    { value: '一月', id: `01` },
    { value: '二月', id: `02` },
    { value: '三月', id: `03` },
    { value: '四月', id: `04` },
    { value: '五月', id: `05` },
    { value: '六月', id: `06` },
    { value: '七月', id: `07` },
    { value: '八月', id: `08` },
    { value: '九月', id: `09` },
    { value: '十月', id: `10` },
    { value: '十一月', id: `11` },
    { value: '十二月', id: `12` },
  ];
  private month: any = '00';
  private colorArr: any = [
    '#4680f5',
    '#54b8b4',
    '#c17bfd',
    '#fdap7b',
    '#fbeb63',
  ];
  private companyInfo: any = null;
  private status: string = '1';
  private action: string = 'view';
  private ant_button: boolean = true;
  private trendData: any;
  private riseObj: any = {
    aboveNumber: 0,
    belowNumber: 0,
    rise: 0,
    riseRate: 0,
    aboveDate: 0,
    // belowDate:0,
  };
  private ids: any = [];
  private dataList: any = null;
  private unitType: number = 0;
  private code: any = null;
  handleSearch(obj: any) {
    const Time = new Date().getFullYear() - 1
    Time == obj.startDate
      ? (this.ant_button = true)
      : (this.ant_button = false)
    this.riseObj.aboveDate = obj.startDate
    this.riseObj.belowDate = obj.endDate
    const params = {
      enterpriseCode: this.code,
      endDate: this.riseObj.belowDate,
      statDate: this.riseObj.aboveDate,
      unitType: this.unitType,
    }
    this.init(params)
  }
  // 弹出日历和关闭日历的回调
  openChangeOne(status: any) {
    if (status) {
      this.yearShowOne = true
    } else {
      this.yearShowOne = false
    }
  }
  // 选择月份
  handleChange(value: any) {
    this.month = value
    if (moment(this.year).format('YYYY') == 'Invalid date') {
      this.$message.error('年份不能为空')
    } else if (value == '00') {
      this.riseObj.aboveDate = `${moment(this.year).format('YYYY')}`
      this.riseObj.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }`
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
      }
      this.init(params)
    } else {
      this.riseObj.aboveDate = `${moment(this.year).format('YYYY')}-${value}`
      this.riseObj.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }-${value}`
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
      }
      this.init(params)
    }
  }
  // 得到年份选择器的值
  onYearChange(value: any) {
    this.year = moment(value).format('YYYY')
    if (this.month == '00') {
      this.riseObj.aboveDate = this.year
      this.riseObj.belowDate =String(this.year - 1)
    } else {
      this.riseObj.aboveDate = `${this.year}-${this.month}`
      this.riseObj.belowDate = `${this.year - 1}-${this.month}`
    }
    // this.riseObj.belowDate= this.riseObj.aboveDate.length==4?this.riseObj.aboveDate-1:this.riseObj.aboveDate
    const params = {
      enterpriseCode: this.code,
      statDate: this.riseObj.aboveDate,
    }
    this.init(params)
    this.yearShowOne = false
    // this.getUtilizationList(this.$route.query.code,this.year)
  }
  init(params: any) {
    this.getConsumTrend(params)
    //   this.getCompanyInfo(params.enterpriseCode)
  }
  //   async getCompanyInfo(code:any){
  //     const {status,data}=await getCompanyInfoRequest({enterpriseCode:code})
  //     if(status==0){
  //       this.companyInfo=data
  //       this.status = data.isOpenData
  //     }
  //   }

  async getConsumTrend(params: any) {
    this.dataList = []
    const { status, data } = await getProductEnergyRequest(params)
    if (status == 0 && data) {
      this.dataList = data
      // console.log(data)
      const that = this
      setTimeout(function () {
        that.handleEharts()
      }, 300)
    } else {
    }
  }
  handleEharts() {
    this.dataList.forEach((ele: any, index: number) => {
      if (ele.gbList.length == 0) {
        ele.gbList = ['-', '-', '-']
      }
      if (ele.dbList.length == 0) {
        ele.dbList = ['-', '-', '-']
      }
      const dataX: any = []
      const dataY: any = []
      ele.outputList.forEach((out: any) => {
        dataX.push(out.statData)
        dataY.push(out.dataValue)
      })
      this.initConsumption(dataX, dataY, index, ele.gbList[0], ele.dbList[0])
    })
  }
  //综合消耗走势图
  initConsumption(dataX: any, dataY: any, id: number, GB: any, DB: any) {
    const main: any = document.getElementById('consumptionEchart' + id)
    main.removeAttribute('_echarts_instance_')
    if (dataY.length === 0) {
      main.innerHTML = ''
    }
    // 基于准备好的dom，初始化echarts实例
    const consumptionEchart: any = echarts.init(main as HTMLDivElement)
    const Ymin = GB > DB ? Number(GB) : Number(DB)

    var Yvalue = [].concat(dataY)

    // 遍历数组，次数就是arr.length - 1
    for (var i = 0; i < Yvalue.length - 1; i++) {
      // 如果前一个数 大于 后一个数 就交换两数位置
      if (Yvalue[i] > Yvalue[i + 1]) {
        var temp = Yvalue[i]
        Yvalue[i] = Yvalue[i + 1]
        Yvalue[i + 1] = temp
      }
    }

    const autoHeight =
      (Yvalue[Yvalue.length - 1] || 0) > Ymin
        ? Number(Yvalue[Yvalue.length - 1])
        : Number(Ymin)
    // 指定图表的配置项和数据
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none',
          crossStyle: {
            color: '#999',
            fontSize: 12,
          },
        },
      },
      grid: {
        left: '70',
        top: '100',
        right: '50',
        bottom: '30',
      },
      xAxis: [
        {
          gridIndex: 0,
          type: 'category',
          data: dataX,
          axisPointer: {
            type: 'shadow',
          },
          axisLine: {
            lineStyle: {
              color: '#ededff',
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#999',
            fontSize: 12,
          },
        },
      ],
      yAxis: [
        {
          max: autoHeight * 1.1 || undefined,
          gridIndex: 0,
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#ededff',
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#999',
            fontSize: 12,
            formatter: '{value}',
          },
        },
      ],
      series: [
        {
          name: '单位产品能耗',
          type: 'bar',
          barWidth: 20, //柱图宽度
          itemStyle: {
            normal: {
              color: '#4680f5',
              borderRadius: 5,
              label: {
                fontSize: 9,
                show: false,
                position: 'top',
              },
            },
          },
          data: dataY,
          markLine: {
            lineStyle: {
              type: 'solid',
              normal: {
                type: 'solid',
                color: '#ff0000',
              },
            },
            data: [
              {
                name: '',
                yAxis: GB,
              },
            ],
          },
        },
        {
          name: '单位产品能耗',
          type: 'line',
          barWidth: '30%',
          smooth: true,
          showSymbol: true,
          symbol: 'emptyCircle', //设定为实心点
          symbolSize: 8, //设定实心点的大小
          tooltip: {
            show: false,
          },
          itemStyle: {
            normal: {
              color: '#ff4747', //改变折线点的颜色
              lineStyle: {
                color: '#ff4747', //改变折线颜色
                width: 2,
              },
              label: {
                show: false,
                position: 'top',
                textStyle: {
                  color: '#0FDBA2',
                },
                formatter: '{value}',
              },
            },
          },
          data: dataY,
          markLine: {
            lineStyle: {
              type: 'solid',
              normal: {
                type: 'solid',
                color: '#8401ff',
              },
            },
            data: [
              {
                name: '',
                yAxis: DB,
              },
            ],
          },
        },
      ],
    }
    // 使用刚指定的配置项和数据显示图表。
    consumptionEchart.setOption(option)
  }
  created() {
    if (this.$route.query.encode != undefined) {
      this.code = this.$route.query.encode.toString()
      this.action = this.$route.query.action.toString()
      this.riseObj.aboveDate = this.$route.query.year
      this.riseObj.belowDate = this.riseObj.aboveDate - 1
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
        unitType: this.unitType,
      }
      this.init(params)
    }
  }
}
